import { Action } from 'redux';
import { NotificationModel, NotificationTypes } from 'models';
import { NotificationsActionTypes } from '../notifications.types';
import { generateRandomId, ACTION_CREATOR_NAME } from 'helpers';

export interface AddNotificationAction extends Action<NotificationsActionTypes.ADD_NOTIFICATION> {
    notification: NotificationModel;
}

export const addNotification: (message: string, type: NotificationTypes) => AddNotificationAction = (message: string, type: NotificationTypes) => ({
    type: NotificationsActionTypes.ADD_NOTIFICATION,
    notification: {
        id: generateRandomId(),
        message,
        type
    }
});
addNotification[ACTION_CREATOR_NAME] = 'addNotification';

export type AddNotificationFunc = (...args: Parameters<typeof addNotification>) => void;